import SearchIcon from "@/components/SVGComponents/SearchIcon";
import CrossIcon from "@/components/SVGComponents/CrossIcon";
import { combineClasses } from "@/lib/utils";
import styles from "./MobileSearchBar.module.scss";

interface MobileSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

// Mobile counterpart of the Table header's search — same controlled
// `search`/`setSearch` pair, so a page can feed both views from one state.
const MobileSearchBar = ({
  value,
  onChange,
  placeholder = "Search",
  className,
}: MobileSearchBarProps) => (
  <div className={combineClasses(styles.searchBox, className)}>
    <SearchIcon className={styles.searchIcon} />
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={placeholder}
    />
    {value && (
      <button
        type="button"
        className={styles.clearButton}
        onClick={() => onChange("")}
        aria-label="Clear search"
      >
        <CrossIcon withBg={false} height={12} width={12} strokeWidth={2} />
      </button>
    )}
  </div>
);

export default MobileSearchBar;
